export default __webpack_public_path__ + "static/media/Montserrat-SemiBold.c9b9096b.woff";